module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/people_without_interaction-e31e145f4d35d6e152b4ce6f0e0c0cda.svg";